/**
 * Pure filtering helpers backing the /documentos catalog search.
 * No React, no hooks/api imports — kept dependency-free so vitest can run
 * this module without jsdom.
 */

/** Strips diacritics and lowercases so 'cedula' matches 'Cédula'. */
export function normalizeSearchText(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}

export function filterDocuments<T extends { name: string; cliente: string; estado: string }>(
  docs: T[],
  opts: { onlyExpiring: boolean; query: string }
): T[] {
  const term = normalizeSearchText(opts.query.trim());
  return docs.filter((d) => {
    const bucketPass = !opts.onlyExpiring || d.estado === 'Por Vencer' || d.estado === 'Vencido';
    const textPass =
      term === '' || normalizeSearchText(d.name).includes(term) || normalizeSearchText(d.cliente).includes(term);
    return bucketPass && textPass;
  });
}
